import classnames from 'classnames';
import { Checkbox } from 'sonata-react-components';

import './solutionCard.scss';

type Props = {
  active: boolean;
  description: string;
  id: string;
  isDisabled?: boolean;
  onChange: (id: string) => void;
  title: string;
};

export function SolutionCard({ active, description, id, isDisabled = false, onChange, title }: Props) {
  const handleClick = () => {
    if (!isDisabled) {
      onChange(id);
    }
  };

  return (
    <div
      className={classnames('solutionCard', {
        'is-active': active,
        'is-disabled': isDisabled
      })}
      data-testid="solutionCard"
      id={`solutionCard-${id}`}
      onClick={handleClick}
    >
      <Checkbox active={active} disabled={isDisabled} id={`solutionCard-checkbox-${id}`} type="radio" />
      <div className="solutionCard__textColumn">
        <div className="solutionCard__title">{title}</div>
        {description && <div className="solutionCard__description">{description}</div>}
      </div>
    </div>
  );
}
